export default __webpack_public_path__ + "static/media/img16.17feabbd.png";